{
  "change": {
    "changed": "Changed",
    "added": "New",
    "removed": "Removed",
    "moved": "Moved",
    "unchanged": "Same"
  },
  "field": {
    "req": "Requirement",
    "nominal": "Nominal",
    "limits": "Limits",
    "type": "Check type",
    "gdt": "GD&T",
    "unit": "Unit",
    "designator": "Designator"
  },
  "value": {
    "blank": "(blank)",
    "none": "none",
    "notSet": "not set"
  },
  "fieldLine": "{{field}}: {{from}} → {{to}}",
  "summary": {
    "changed": "{{count}} changed",
    "added": "{{count}} new",
    "removed": "{{count}} removed",
    "moved": "{{count}} moved",
    "unchanged": "{{count}} the same",
    "none": "No changes",
    "sep": ", ",
    "aria": "Summary"
  },
  "rev": "Rev {{rev}}",
  "toast": {
    "applied": "Balloons carried forward. {{summary}}.",
    "undo": "Undo",
    "undone": "Undone. Balloon numbers are back as read from the drawing.",
    "busy": "Another drawing is still uploading. Try again in a moment.",
    "opening": "Opening {{name}}",
    "openFailed": "Could not open that file.",
    "read_one": "{{count}} characteristic read. Review what changed from the last revision.",
    "read_other": "{{count}} characteristics read. Review what changed from the last revision.",
    "savedWithError": "The drawing is saved. {{error}}",
    "savedNotRead": "The drawing is saved. Place balloons, then compare with the last revision."
  },
  "newRev": {
    "title": "Start a new revision",
    "sub": "Upload the new drawing for {{part}}. Deburr reads it, matches every characteristic to Rev {{rev}} ({{fai}}) and keeps the balloon numbers.",
    "thisPart": "this part",
    "submit": "Upload and compare",
    "badFile": "Pick a PDF, PNG or JPG drawing.",
    "noFile": "Choose the new drawing first.",
    "chooseAnother": "{{size}}. Click to choose another.",
    "drop": "Drop the new drawing here",
    "dropSub": "or click to choose a PDF, PNG or JPG",
    "label": "New revision",
    "hint": "The last one is Rev {{rev}}. The title block wins if it says otherwise.",
    "deltaLabel": "Delta FAI:",
    "deltaBody": "only inspect what changed. Unchanged characteristics are carried over from {{fai}} and the partial scope (Form 1) is filled in for you."
  },
  "review": {
    "title": "What changed from Rev {{rev}}",
    "titlePlain": "What changed",
    "sub": "{{fai}} Rev {{rev}} compared with {{baseline}}. Matched characteristics keep their balloon numbers.",
    "undoApply": "Undo last apply",
    "later": "Later",
    "acceptAll": "Accept all and apply",
    "applyAgain": "Apply again",
    "apply": "Apply",
    "emptyTitle": "Nothing to compare yet",
    "noNew": "This FAI has no characteristics yet. Read the drawing or place balloons, then compare with the last revision.",
    "noneEither": "Neither revision has characteristics yet.",
    "alreadyApplied": "Already applied. Changing a match and applying again renumbers to match.",
    "needLook_one": "{{count}} match needs a look.",
    "needLook_other": "{{count}} matches need a look.",
    "needLookBody": "Check them below, or accept all. Sure matches are already accepted.",
    "deltaLabel": "Delta FAI:",
    "deltaBody": "only inspect changed and new characteristics",
    "scope": "Form 1 partial scope:",
    "show": "Show",
    "filterUnsure": "Needs a look ({{count}})",
    "filterChanges": "Changes",
    "filterAll": "All ({{count}})",
    "compareDrawings": "Compare drawings",
    "noneUnsure": "Every match is sure. Nothing needs a look.",
    "noneChanges": "No changes. Every characteristic matches the last revision.",
    "noneAll": "Nothing here.",
    "newNumber": "New balloon number",
    "keptNumber": "Balloon number (kept from the last revision)",
    "notOnNew": "not on the new drawing",
    "movedSheets": "moved from sheet {{from}} to {{to}}",
    "movedOnSheet": "moved on the sheet",
    "howSure": "How sure Deburr is about this match",
    "unsureMatch": "Unsure match, {{pct}}",
    "mightMatch": "Might match an old one",
    "yourChoice": "Your choice",
    "sureMatch": "Sure match, {{pct}}",
    "sameAs": "Same as",
    "matchFor": "Match for balloon {{n}}",
    "nothingNew": "Nothing, it is new",
    "candidate": "Rev {{rev}} balloon {{n}}: {{req}} ({{pct}})",
    "accept": "Accept",
    "reinspect": "Re-inspect anyway",
    "showOnDrawings": "Show on the drawings",
    "showBalloon": "Show balloon {{n}} on the drawings"
  },
  "compare": {
    "dockLabel": "{{part}} compare",
    "dockLabelPlain": "Compare",
    "docTitle": "Compare {{part}} Rev {{from}} to {{to}}",
    "title": "Compare revisions",
    "back": "Back",
    "heading": "{{part}} Rev {{from}} → Rev {{to}}",
    "earlierFai": "Earlier FAI",
    "thisFai": "this FAI",
    "comparedWith": "<base/> compared with <current/>",
    "notFound": "Inspection not found",
    "pickTitle": "Pick the earlier FAI to compare with",
    "pickLabel": "Earlier FAI",
    "pickChoose": "Choose an FAI",
    "pickOption": "{{fai}}, Rev {{rev}}",
    "compare": "Compare",
    "notLinked": "This FAI is not linked to an earlier revision yet.",
    "noOther": "There is no other FAI for this part yet. Start a new revision from the part page to compare drawings.",
    "noImagesTitle": "No drawing images to compare",
    "noImagesBody": "The drawing images for sheet {{page}} are not available. The change list still shows what changed.",
    "sheetAlt": "Rev {{rev}} sheet {{page}}",
    "drawings": "Drawings",
    "view": "View",
    "overlay": "Overlay",
    "side": "Side by side",
    "swipe": "Swipe",
    "sheet": "Sheet",
    "sheetN": "Sheet {{page}}",
    "opacity": "Rev {{rev}} opacity",
    "swipePos": "Swipe position",
    "zoomOut": "Zoom out",
    "zoomIn": "Zoom in",
    "fit": "Fit",
    "changes": "Changes",
    "reviewMatches": "Review matches",
    "reviewApply": "Review and apply",
    "notApplied": "Not applied yet: balloon numbers on {{fai}} are still as read from the drawing.",
    "onSheet": ", sheet {{page}}",
    "noChanges": "No changes between these revisions. Every characteristic matches.",
    "legend": "Legend",
    "onlyOn": "Only on Rev {{rev}}",
    "onBoth": "On both",
    "notOnRev": "Not on this revision",
    "markTitle": "{{label}}: balloon {{n}}, {{req}}",
    "markAria": "{{label}} balloon {{n}}"
  },
  "timeline": {
    "empty": "No first articles on this part yet. When the drawing changes, start a new revision and Deburr shows what changed.",
    "hint": "When the drawing changes, start a new revision: Deburr matches every characteristic, keeps balloon numbers and fills in a delta FAI.",
    "newRevision": "New revision",
    "latest": "Latest",
    "delta": "Delta",
    "full": "Full",
    "faiMeta": "{{type}}, {{date}}",
    "from": "From Rev {{rev}}:",
    "nothingYet": "no characteristics to compare yet",
    "compareDrawings": "Compare drawings",
    "carry": "Carry balloons forward"
  }
}
